(function(){
  /*
   * v3: Kein Bild-Austausch mehr noetig - die Slideshow-Sektion nutzt jetzt direkt
   * das reparierte Panorama (vs-home-hero-v2.png, Koepfe vervollstaendigt) als
   * natives Sektions-Bild inkl. srcset. Hier wird nur noch der Theme-Hintergrund
   * der Hero-Flaeche abgesichert.
   */
  function f(){
    var legacy=document.getElementById('vs-real-hero'); if(legacy) legacy.remove();
    document.querySelectorAll('[id*=slideshow_jHz8Rk] .banner__media').forEach(function(m){
      m.style.setProperty('background','#E9ECEF','important');
      m.style.setProperty('background-image','none','important');
    });
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',f):f();
  setTimeout(f,1500);
})();
